export default __webpack_public_path__ + "static/media/element_spec_44.158b5d6e.webp";